import { render, staticRenderFns } from "./TotalQc.vue?vue&type=template&id=31325e6a&"
import script from "./TotalQc.vue?vue&type=script&lang=js&"
export * from "./TotalQc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports